import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },

  container: {
    opacity: 0,
    animation: '$fadeIn 0.5s',
    'animation-fill-mode': 'forwards',
  },

  creditCardIcon: {
    marginBottom: '20px',
  },

  nextButton: (props: { baseColors: BaseColors }) => {
    return {
      display: 'flex',
      margin: '10px',
      justifyContent: 'center',
      alignItems: 'center',
      width: '50%',
      padding: '5px',
      borderRadius: '15px',
      backgroundColor: props.baseColors.secondary,
      cursor: 'pointer',
    }
  },

  nextButtonSpan: {
    height: '38px',
    display: 'inline-block',
    letterSpacing: '0.05em',
    lineHeight: '38px',
    fontSize: '25px',
    color: '#ffffff',
    fontFamily: 'Mulish',
  },
}))

export default buildStyles
